<style scoped lang="scss">
@import '$vars';
button {
  position: relative
}

.loading::after {
  border: 3px solid #fff;
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
}

.loading, .icon {
  width: 1em;
  position: absolute;
  left: calc(50% - 0.5em);
  top: calc(50% - 0.5em);
}
</style>

<template>
  <button :disabled="sending || disabled" :type="type || 'submit'" class="btn" :class="(size ? `btn-${size} ` : '') + (color ? `btn-${color}` : 'btn-primary')" @click="click()">
    <span v-if="sending">
      <span class="invisible">{{text}}</span>
      <transition name="fade">
        <span v-if="sending === 2" class="icon icon-check"></span>
        <span v-else class="loading"></span>
      </transition>
    </span>
    <span v-else>
      <span>{{text}}</span>
    </span>
  </button>
</template>

<script>
export default {
  props: [
    'text',
    'sending',
    'size',
    'disabled',
    'type',
    'color'
  ],
  methods: {
    click () {
      this.$emit('click', true)
    }
  }
}
</script>
